import React, { useEffect, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";
import "./callibrage.css";
import iconRightArrow from "../../../assets/images/icon-right-arrow.png";
import { Button, Form, InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import clsx from "clsx";

const Callibrage = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [closeAnimation, setCloseAnimation] = useState(false);

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <InputGroup id="small-calendar" onClick={onClick}>
      <Form.Control
        style={{ borderRadius: "5px" }}
        placeholder="jj/mm/aaaa"
        defaultValue={value}
        ref={ref}
      />
      <div className="search-icon">
        <img width={"20px"} />
      </div>
    </InputGroup>
  ));

  return (
    <div
        className={clsx({"callibrage-container": props.openCallibrage }, {"callibrage-container-close": closeAnimation})}
        >
      <div className="left-side-callibrage"></div>
      <div className="right-side-callibrage">
        <div className="container-topbar-of-callibrage">
          <div className="container-icon-arraw-left">
            <img src={iconRightArrow} />
          </div>
          <h5 style={{ marginBottom: "0" }}>Callibrage de l'évaluation </h5>
        </div>

        <div className="form-callibrage">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Les participant</Form.Label>
            <Form.Control
              style={{ color: "#B7B7B7" }}
              name="email"
              type="email"
              placeholder="Identifiant"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>La date limite</Form.Label>
            <div style={{ width: "50%" }}>
              <DatePicker
                popperPlacement="bottom-end"
                className="red-border date-input"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                placeholderText="jj/mm/aaaa"
                customInput={<ExampleCustomInput />}
              />
            </div>

            <div className="container-buttons-callibrage">
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "#5800e2",
                  borderColor: "#5800e2",
                  float: "right",
                }}
              >
                Envoyer
              </Button>

              <Button
                variant="primary"
                className="buttons button-annuler-callibrage"
                onClick={()=> {props.closeCallibrage(); setCloseAnimation(true)}}
              >
                Annuler
              </Button>
            </div>
          </Form.Group>
        </div>
      </div>
    </div>
  );
};

export default Callibrage;
